import React from 'react';
import { DndProvider } from 'react-dnd';
import { MultiBackend } from 'react-dnd-multi-backend';
import { HTML5toTouch } from 'rdndmb-html5-to-touch';

/**
 * Creates and installs the Connected History Router
 */
export default {
  id: 'molten.DragAndDrop',
  sort: -25,
  createProvider: (molten, ...children) => {
    return /*#__PURE__*/React.createElement(DndProvider, {
      backend: MultiBackend,
      options: HTML5toTouch
    }, ...children);
  }
};